<div class="edit-agenda-item d-flex flex-column">
    <div class="d-flex flex-row hover-container">
        <ng-container *ngIf="(readonly || isMeetingInProgress) && !hideProgressIcon">
            <i class="me-2 align-self-center fal fa-2x fa-check-circle show-icon-on-print"
               [ngClass]="progressColor"
               [adaptTooltip]="progressColor"></i>
        </ng-container>
        <div class="d-flex flex-column flex-grow-1 align-items-start"
             [attr.role]="canExpand ? 'button' : null"
             (click)="toggleExpand()">
            <h4 class="d-flex flex-grow-1 pe-3">
                <span class="d-flex align-items-center agenda-item-expand">
                    <h4 class="text-start">{{item.name}}</h4>

                    <adapt-agenda-item-meta-data-count *ngIf="!hideNotesAndItems"
                                                       class="flex-grow-1 text-start ms-1"
                                                       [showTotalBadgeOnly]="true"
                                                       [meetingNotes]="agendaNotes"
                                                       [meetingItemLinks]="agendaActionLinks"
                                                       [objectiveLinks]="agendaObjectiveLinks">
                    </adapt-agenda-item-meta-data-count>

                    <i *ngIf="canExpand"
                       class="ms-1 align-self-center fal fa-fw"
                       [ngClass]="expandDetails ? 'fa-chevron-up': 'fa-chevron-down'"></i>
                </span>
            </h4>
            <div *ngIf="item.plannedDurationInMinutes"
                 class="agenda-item-time text-start">
                <i class="fal fa-clock me-1"></i>
                <span>{{item.plannedDurationInMinutes}} </span>
                <span>mins</span>
            </div>
        </div>
        <div class="d-flex align-self-sm-center ms-sm-auto">
            <ng-container *ngIf="!readonly">
                <!-- only show the menu if the agenda item is already saved,
                 otherwise if agenda item is new in a dialog, trying to save notes, action links will not be allowed.
                 Too many things to worry about during meeting creation to add links and notes anyway!
                 Only item attached to a meeting will see this menu - make no sense to attach any of these to template -->
                @if (!isNewAgendaItem && !item.extensions.isFacilitationNotes && !item.extensions.isPreWork && !!item.meetingId) {
                    <adapt-agenda-item-action-menu [agendaItem]="item"
                                                   (actionPerformed)="expandDetails = true"
                                                   (visibilityChanged)="menuVisible = $event"
                                                   class="ms-2 hover-action"
                                                   [ngClass]="{'hover-action-visible': menuVisible}"></adapt-agenda-item-action-menu>
                }

                <button adaptButton="editBorderless"
                        class="ms-3 align-self-center"
                        adaptTooltip="Edit agenda item"
                        [adaptBlockingClick]="editItemDetails"></button>
                <button adaptButton="deleteBorderless"
                        class="ms-1 align-self-center"
                        adaptTooltip="Delete agenda item"
                        [adaptBlockingClick]="deleteItem"
                        [unsubscribeOnDestroy]="false"></button>

                @if (item.extensions.isFacilitationNotes || item.extensions.isPreWork) {
                    <!-- This is not sortable - add the padding span here using exactly the same class as dxList handle to ensure it matches the width to align -->
                    <span class="dx-list-item-after-bag dx-list-reorder-handle-container"></span>
                }
            </ng-container>
        </div>
    </div>

    <div *ngIf="canExpand && expandDetails"
         class="pt-3">
        @if (showItemDescription) {
            <div class="text-wrap"
                 [froalaView]="item.supplementaryData?.itemDescription"></div>

            <div *ngIf="item.componentSelector"
                 class="alert alert-secondary text-wrap my-3">
                <ng-container #container></ng-container>
            </div>
        }

        <ng-container *ngIf="!hideNotesAndItems">
            @if (showBothDecisionsAndNotes) {
                <adapt-display-meeting-note *ngFor="let note of agendaNotes"
                                            [edit]="!readonly"
                                            [note]="note"></adapt-display-meeting-note>
            } @else if (showDecisions) {
                <adapt-display-meeting-note *ngFor="let note of filterNotesByType(agendaNotes, MeetingNoteType.Decision)"
                                            [edit]="!readonly"
                                            [note]="note"></adapt-display-meeting-note>
            } @else if (showMinutes) {
                <adapt-display-meeting-note *ngFor="let note of filterNotesByType(agendaNotes, MeetingNoteType.Minute)"
                                            [edit]="!readonly"
                                            [note]="note"></adapt-display-meeting-note>
            }

            @if (showActions) {
                <adapt-display-action-link *ngFor="let link of agendaActionLinks"
                                           [showDeleteLink]="!readonly"
                                           [link]="link"></adapt-display-action-link>
            }

            @if (showObjectives) {
                <adapt-display-meeting-objective-link *ngFor="let link of agendaObjectiveLinks"
                                                      [showDeleteLink]="!readonly"
                                                      [link]="link"></adapt-display-meeting-objective-link>
            }
        </ng-container>
    </div>
</div>
